export default __webpack_public_path__ + "static/media/green development area icon.a3037745.svg";